<template>
  <article>
    <header>
      <el-tag
        class="title"
        v-for="(item, index) in titles"
        :key="index"
        :type="item.type"
        :effect="item.effect"
        size="mini"
      >{{ item.name}}</el-tag>
      <h2>Nombre d'évènements: <span class="count">{{ gamesShow }} / {{ count }}</span></h2>
    </header>
    <div class="games">
      <game
        v-for="item in games"
        :key="item.id"
        :game="item"
        :season="seasonsId.length > 1"
        :competition="competitionsId.length > 1"
        :roundType="roundsTypeId.length > 1"
        :groupType="groupsTypeId.length > 1"
        :gender="gendersId.length > 1"
        :discipline="disciplinesId.length > 1"
        :sport="sportsId.length > 1"
        :event="eventsId.length > 1"
        :eventUnit="eventUnitsId.length > 1"
        v-show="gameShow(item)"/>
    </div>
  </article>
</template>

<script>
import Game from '@/components/sport/games/Game'
export default {
  name: 'SportGamesMain',
  components: { Game },
  props: {
    games: Array,
    statuses: Array,
    filters: Array
  },
  computed: {
    count () { return this.games.length },

    seasonsFull () { return this.$store.getters['Sport/Season/list'] },
    competitionsFull () { return this.$store.getters['Sport/Competition/list'] },
    roundsTypeFull () { return this.$store.getters['Sport/RoundType/list'] },
    groupsTypeFull () { return this.$store.getters['Sport/GroupType/list'] },
    gendersFull () { return this.$store.getters['Sport/Gender/list'] },
    disciplinesFull () { return this.$store.getters['Sport/Discipline/list'] },
    sportsFull () { return this.$store.getters['Sport/Sport/list'] },
    eventsFull () { return this.$store.getters['Sport/Event/list'] },
    eventUnitsFull () { return this.$store.getters['Sport/EventUnit/list'] },

    seasonsId () { return [...new Set(this.games.map(item => item.seasonId))] },
    competitionsId () { return [...new Set(this.games.map(item => item.competitionId))] },
    roundsTypeId () { return [...new Set(this.games.map(item => item.roundTypeId))] },
    groupsTypeId () { return [...new Set(this.games.map(item => item.groupTypeId))] },
    gendersId () { return [...new Set(this.games.map(item => item.genderId))] },
    disciplinesId () { return [...new Set(this.games.map(item => item.disciplineId))] },
    sportsId () { return [...new Set(this.games.map(item => item.sportId))] },
    eventsId () { return [...new Set(this.games.map(item => item.eventId))] },
    eventUnitsId () { return [...new Set(this.games.map(item => item.eventUnitId))] },

    seasonsFilter () { return this.seasonsFull.filter(item => this.seasonsId.indexOf(item.id) > -1) },
    competitionsFilter () { return this.competitionsFull.filter(item => this.competitionsId.indexOf(item.id) > -1) },
    roundsTypeFilter () { return this.roundsTypeFull.filter(item => this.roundsTypeId.indexOf(item.id) > -1) },
    groupsTypeFilter () { return this.groupsTypeFull.filter(item => this.groupsTypeId.indexOf(item.id) > -1) },
    gendersFilter () { return this.gendersFull.filter(item => this.gendersId.indexOf(item.id) > -1) },
    disciplinesFilter () { return this.disciplinesFull.filter(item => this.disciplinesId.indexOf(item.id) > -1) },
    sportsFilter () { return this.sportsFull.filter(item => this.sportsId.indexOf(item.id) > -1) },
    eventsFilter () { return this.eventsFull.filter(item => this.eventsId.indexOf(item.id) > -1) },
    eventUnitsFilter () { return this.eventUnitsFull.filter(item => this.eventUnitsId.indexOf(item.id) > -1) },

    titles () {
      const list = []
      this.initTitle(this.seasonsFilter, 'name', 'success', list)
      this.initTitle(this.competitionsFilter, 'nameFr', 'info', list)
      this.initTitle(this.sportsFilter, 'name', 'warning', list)
      this.initTitle(this.disciplinesFilter, 'nameFr', 'danger', list)
      this.initTitle(this.eventsFilter, 'nameFr', 'info', list)
      this.initTitle(this.gendersFilter, 'nameFr', 'success', list)
      this.initTitle(this.eventUnitsFilter, 'nameFr', 'info', list)
      this.initTitle(this.roundsTypeFilter, 'name', 'warning', list)
      this.initTitle(this.groupsTypeFilter, 'name', 'danger', list)
      return list
    },
    gamesShow () {
      let count = 0
      for (const i in this.games) {
        if (this.gameShow(this.games[i])) {
          count++
        }
      }
      return count
    }
  },
  methods: {
    gameShow (item) {
      const seasonKey = 's' + item.seasonId
      const competitionKey = 'c' + item.competitionId
      const roundTypeKey = 'rt' + item.roundTypeId
      const genderKey = 'g' + item.genderId
      const disciplineKey = 'd' + item.disciplineId
      const sportKey = 'sp' + item.sportId
      const eventKey = 'e' + item.eventId
      const eventUnitKey = 'eu' + item.eventUnitId

      let value = this.filters.indexOf(seasonKey) === -1 &&
        this.filters.indexOf(competitionKey) === -1 &&
        this.filters.indexOf(roundTypeKey) === -1 &&
        this.filters.indexOf(genderKey) === -1 &&
        this.filters.indexOf(disciplineKey) === -1 &&
        this.filters.indexOf(sportKey) === -1 &&
        this.filters.indexOf(eventKey) === -1 &&
        this.filters.indexOf(eventUnitKey) === -1 &&
        (this.statuses.length === 0 || this.statuses.indexOf(item.statusId) > -1)

      if (item.groupType) {
        const groupTypeKey = 'gt' + item.groupTypeId
        value = value && this.filters.indexOf(groupTypeKey) === -1
      }

      return value
    },
    initTitle (list, name, type, destination) {
      if (list.length === 1) {
        destination.push({ name: list[0][name], type: type, effect: 'dark' })
      }
    }
  }
}
</script>

<style scoped>
  article{
    flex:1 1 auto;
    margin:0 10px 10px 0
  }
  article > header{
    display:flex;
    align-items:center;
    margin-bottom:10px
  }
  article > header > .title{
    margin:10px 5px
  }
  article > header{
    position:sticky;
    top:40px;
    background-color:var(--color-background-bg);
    z-index:1;
    padding-top:10px
  }
  article > header > h2{
    font-size:14px;
    margin:0;
    color:var(--color-disable-bg);
    white-space:nowrap
  }
  article > header > h2 > span{
    color:var(--color-disable)
  }
  article > .games{
    position:relative;
    z-index:0
  }
</style>
